module.exports = __webpack_public_path__ + "img/Cry.26b11388.png";